import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface ExpofeiraData {
  total_avaliacoes?: number;
  media_por_categoria?: Array<{ category: string; avg: number }>;
  media_total?: number;
}

interface BarChartProps {
  data?: ExpofeiraData;
  style?: React.CSSProperties; // ✅ novo prop
}

export const ExpofeiraChart: React.FC<BarChartProps> = ({ data, style }) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const total_avaliacoes = data?.total_avaliacoes ?? 0;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const media_por_categoria = data?.media_por_categoria ?? [];
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const media_total = data?.media_total ?? 0;

  const isLoading = !data?.media_por_categoria;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const getColor = (value: number) => {
    if (value >= 5) return '#2A2C85';
    if (value >= 4) return '#5C68F8';
    if (value >= 3) return '#A1B6FF';
    if (value >= 2) return '#EDF3FF';
    return '#EDF3FF';
  };

  const chartData = {
    labels: media_por_categoria.map((item) => item.category),
    datasets: [
      {
        label: 'Média',
        data: media_por_categoria.map((item) => item.avg ?? 0),
        backgroundColor: media_por_categoria.map((item) => getColor(item.avg ?? 0)),
        borderRadius: {
          topLeft: 0,
          topRight: 6,
          bottomLeft: 0,
          bottomRight: 6,
        },
        maxBarThickness: 20,
        borderSkipped: false,
      },
    ],
  };

  const options = {
    responsive: true,
    indexAxis: 'y' as const,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true },
      datalabels: { display: false },
    },
    scales: {
      x: {
        min: 0,
        max: 5,
        ticks: { stepSize: 1 },
        grid: {
          drawTicks: false,
          drawOnChartArea: false,
        },
      },
      y: { ticks: { autoSkip: false } },
    },
  };

  const defaultStyle: React.CSSProperties = {
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '1rem',
    // maxWidth: '654px',
    // minWidth: 304,
    // width: '100%',
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
  };

  return (
    <div style={{ ...defaultStyle, ...style }}>
      {/* Header */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '1rem',
          alignItems: 'center',
        }}
      >
        <h3 style={{ margin: 0, fontSize: 16, color: '#5A5A5A' }}>Avaliação - Expofeira</h3>
        <span style={{ fontWeight: 500, fontSize: 16, color: '#5A5A5A' }}>
          {isLoading ? '...' : `${media_total}/5`}
        </span>
      </div>

      {/* Chart */}
      {isLoading ? (
        <div
          style={{
            height: '200px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#999',
          }}
        >
          ...
        </div>
      ) : (
        <Bar data={chartData} options={options} />
      )}

      {/* Footer */}
      <div style={{ textAlign: 'right', marginTop: '0.75rem' }}>
        <span style={{ fontSize: 14, color: '#5A5A5A' }}>
          Total de avaliações:{' '}
          <span style={{ fontSize: 14, color: '#2A2C85' }}>
            {isLoading ? '...' : total_avaliacoes}
          </span>
        </span>
      </div>
    </div>
  );
};
